import { Box, Button, IconButton, Tooltip } from "@mui/material"
import Datatable from "../../../components/features/Datatable"
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import BsModal from "../../../components/common/BaseModal";
import { DeleteIconButton, EditIconButton } from "../../../../assets/common-svg/CommonSvg";
import DeleteModal from "../../../components/common/BaseModal/DeleteModal";
import AddStateForm from "./addStateForm";
import { deleteState, disableAddModal, enableAddModal, fetchAllState } from "../../../slices/state";

const normalizeStateItems = (items = []) =>
    items.map((item) => ({
        ...item,
        country_name:
            item?.country_name ||
            item?.country?.name ||
            item?.country?.country_name ||
            item?.country_details?.name ||
            item?.country_details?.country_name ||
            "N/A",
    }));

const StateManagement = () => {
    const dispatch = useDispatch()
    const [rowData, setRowData] = useState(null)
    const [open, setOpen] = useState(false)
    const [loading, setLoading] = useState(false)
    const { isLoading, addModal } = useSelector((state) => state.bmrState);
    const [filters, setFilters] = useState({});
    const [currentSearch, setCurrentSearch] = useState("");
    const [stateData, setStateData] = useState({
        items: [],
        total_count: 0,
        page: 1,
        per_page: 10,
    })
    const searchDebounceRef = useRef(null);
    const columns = [
        {
            id: 'id',
            name: 'State ID',
            align: "left",
            selector: row => row.id,
            sortable: true
        },
        {
            id: 'country_name',
            align: "center",
            name: 'Country Name',
            selector: row => row.country_name,
            sortable: true
        },
        {
            id: 'name',
            name: 'State Name',
            align: "center",
            selector: row => row.name,
            sortable: true
        },
        {
            id: 'state_code',
            align: "center",
            name: 'State Code',
            selector: row => row.state_code,
            sortable: true
        },
        
        {
            name: 'Action',
            align: "center",
            selector: row => <Box key={row.id}>
                <Tooltip title="Edit" >
                    <span>
                        <IconButton
                            onClick={() => { setRowData(row), handleAddModal() }}
                        >
                            <EditIconButton
                                bgColor={"#C3C3C3"}
                            />
                        </IconButton>
                    </span>
                </Tooltip>
                <Tooltip title={row.is_used ? "Cannot delete: State is in use" : "Delete"} >
                       <span style={{ 
        cursor: row.is_used ? 'not-allowed' : 'pointer',
        display: 'inline-block',
        pointerEvents: row.is_used ? 'all' : 'auto' 
    }}>
                        <IconButton
                            onClick={() => { if (!row.is_used) { setRowData(row); setOpen(true); } }}
              sx={{
              pointerEvents: row.is_used ? 'none' : 'auto', 
            }}
                        >
                            <DeleteIconButton
                                bgColor={"#FA5151"}
                            />
                        </IconButton>
                    </span>
                </Tooltip>
            </Box>,
        },
    ];

    const handleCloseModal = async () => {
        await dispatch(disableAddModal())
    }
    const handleAddModal = async () => {
        await dispatch(enableAddModal())
    }
    const removeState= async () => {
    const { id } = rowData;
    await dispatch(deleteState({ id }));
    setOpen(false);
    handleServerSideChange({
        page: stateData.page,
        per_page: stateData.per_page,
        search: currentSearch
    });
};
   const handleServerSideChange = async (params) => {
    const searchValue = params.search || '';
    const currentPage = params.page || 1;
    const currentPerPage = params.per_page || stateData.per_page || 10;
    setCurrentSearch(searchValue);
    const trimmedSearch = searchValue.trim();

    try {
        setLoading(true);

        // if (trimmedSearch === '') {
            const result = await dispatch(fetchAllState({
                page: currentPage,
                limit: currentPerPage,
                search: trimmedSearch || undefined,
                sort_by: params.sort_by || 'id',
                order_by: params.sort_order || 'desc'
            })).unwrap();

            setStateData({
                items: normalizeStateItems(result?.data || []),
                total_count: result?.page_details?.no_of_records || 0,
                page: result?.page_details?.page || currentPage,
                per_page: result?.page_details?.limit || currentPerPage,
            });

    } catch (error) {
        console.error("Error fetching state list:", error);
    } finally {
        setLoading(false);
    }
}
const updateFilter = async(params) => {
        const {
            page = 1,
            per_page = 10,
            search = '',
            ...appliedFilters
        } = params;

        const isFilterChanged = JSON.stringify(filters) !== JSON.stringify(appliedFilters);
        const finalPage = isFilterChanged ? 1 : page;

        setFilters(appliedFilters);
  const isSearchChange = search !== currentSearch;
    if (isSearchChange) {
        if (searchDebounceRef.current) clearTimeout(searchDebounceRef.current);
        searchDebounceRef.current = setTimeout(() => {
            handleServerSideChange({
                page: finalPage,
                per_page,
                search,
                sort_by: params.sort_by,
                sort_order: params.sort_order
            });
        }, 400);
    } else {
        await handleServerSideChange({
            page: finalPage,
            per_page,
            search,
            sort_by: params.sort_by,
            sort_order: params.sort_order
        });
    }
    };

    useEffect(() => {
        handleServerSideChange({ page: 1, per_page: 10, search: "" });
    }, []);
    return <div className="!p-6">
        <div className="!p-4 mt-3 bg-white flex flex-col gap-4">
            <BsModal
                open={addModal}
                onClose={handleCloseModal}
                title={rowData ? "Edit State" : "Add New State"}>
                <AddStateForm editData={rowData}  onSuccess={() => {
        handleCloseModal();
        handleServerSideChange({ 
            page: stateData.page,      
            per_page: stateData.per_page, 
            search: currentSearch     
        });
        setRowData(null);
    }}   />
            </BsModal>
            <Datatable
                columns={columns}
                data={{
                    items: stateData.items,
                    total_count: stateData.total_count
                }}
                title="State"
                searchPlaceholder="Search by Country/State name"
                loading={isLoading || loading}
                BtnComponent={<Button className="ml-2"
                    onClick={() => (handleAddModal(), setRowData(null))}
                >Add New State</Button>}
                remote={true}
                onServerSideChange={updateFilter}
            />
            <DeleteModal
                open={open}
                setClose={setOpen}
                title={"Are you sure you want to Delete ?"}
                buttonText={"Delete"}
                handleSuccess={removeState}
            />
        </div>
    </div>
}
export default StateManagement
